import React from "react";
import { Link } from "react-router-dom";
import { CreditCard, Lock, FileText, CheckCheck, Scale, BadgeCheck, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { TRUST_POINTS } from "@/data/content";

const ICON_MAP = { CreditCard, Lock, FileText, CheckCheck, Scale, BadgeCheck };

export const TrustSection = () => {
  return (
    <section id="trust" data-testid="trust-section" className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading overline="Trust & safety" title="Trust built in." center />
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 gap-4">
          {TRUST_POINTS.map((point, i) => {
            const Icon = ICON_MAP[point.icon];
            return (
              <Reveal key={point.text} delay={(i % 3) * 0.06}>
                <div
                  data-testid={`trust-point-${i}`}
                  className="h-full bg-white rounded-2xl border border-slate-100 soft-shadow p-6 flex items-center gap-4"
                >
                  <div className="h-11 w-11 rounded-xl bg-[#ecfdf3] flex items-center justify-center shrink-0">
                    <Icon className="h-5 w-5 text-[#16a34a]" />
                  </div>
                  <span className="text-[15px] font-semibold text-[#091630] leading-snug">{point.text}</span>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 max-w-3xl mx-auto rounded-2xl bg-slate-50 border border-slate-100 p-6 text-center">
            <p className="text-sm text-slate-500 leading-relaxed">
              Workpay is not a bank, wallet, payment gateway, or escrow provider. Workpay provides software for
              project payment management. Payments are processed through Stripe.
            </p>
            <Link
              to="/how-payments-work"
              data-testid="trust-how-payments-work"
              className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#16a34a] hover:gap-2.5 transition-all"
            >
              How payments work <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default TrustSection;
